// Features/TeeInBlue-Product-Layout/WaitFor.ts
var waitFor = function(selector) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(interval);
        resolve(element);
        return;
      }
    }, 300);
  });
};

// Features/TeeInBlue-Product-Layout/mod.ts
async function styleDots() {
  const cart = await fetch("/cart.js").then((response) => response.json());
  const count = cart.item_count;
  if (!count)
    return;
  if (count < 1)
    return;
  document.querySelectorAll(Selector_Dots).forEach((dot) => dot.classList.add("is-visible"));
}
var Event_Added_To_Cart = `teeinblue-event-after-cart-added`;
var Selector_Description = `.ProductMeta__Description`;
var Selector_Container = `.Product__Info > .Container`;
var Selector_AddToCart = `.tee-btn--atc`;
var Selector_Title = `.ProductMeta__Title`;
var Selector_Icon = `.tee-btn--atc-icon-right`;
var Selector_Dots = `.Header__CartDot`;
document.addEventListener(Event_Added_To_Cart, styleDots);
var container = document.querySelector(Selector_Container);
var description = document.querySelector(Selector_Description);
if (description)
  container?.append(description);
var title = document.querySelector(Selector_Title);
if (title)
  container?.prepend(title);
var icon = document.querySelector(Selector_Icon);
if (icon)
  waitFor(Selector_AddToCart).then((button) => button.append(icon));
